import { useEffect, useId, useRef } from "react"
import "trix"
import "trix/dist/trix.css"

interface TrixFieldProps {
  value: string
  onChange: (html: string) => void
  placeholder?: string
  minHeight?: string
}

export default function TrixField({ value, onChange, placeholder, minHeight = "140px" }: TrixFieldProps) {
  const reactId = useId().replace(/:/g, "_")
  const inputId = `trix-input-${reactId}`
  const editorRef = useRef<HTMLElement | null>(null)

  useEffect(() => {
    const editor = editorRef.current
    if (!editor) return
    const handler = (e: Event) => {
      const target = e.target as HTMLInputElement
      onChange(target.value || "")
    }
    editor.addEventListener("trix-change", handler)
    return () => editor.removeEventListener("trix-change", handler)
  }, [onChange])

  return (
    <div style={{ ["--trix-min-height" as string]: minHeight }}>
      <input id={inputId} type="hidden" defaultValue={value || ""} />
      {/* @ts-expect-error trix-editor is a custom element registered by `trix` */}
      <trix-editor
        ref={editorRef}
        input={inputId}
        placeholder={placeholder}
        class="trix-content"
        style={{ minHeight, background: "var(--color-panel-solid)", borderRadius: 4 }}
      />
    </div>
  )
}
